import {Presenter} from '../../../../Support/with_presenter';
import {WorkoutsService} from '../../../../Network/WorkoutsService';
import {NetworkRequestStatus} from '../../../../Network/NetworkResult';

export class EditTitleFormPresenter implements Presenter {
    public title = '';
    public isEditing: boolean = false;
    public isEdited = false;
    public isSaving = false;

    constructor(private id: number, private workoutService: WorkoutsService) {}

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

    public toggleEdit(title: string): void {
        this.isEditing = !this.isEditing;
        this.title = title;
    }

    public setTitle(value: string): void {
        this.title = value;
    }

    public async submit() {
        try {
            this.isSaving = true;
            const result = await this.workoutService.update(this.id, this.title);
            if (result.status === NetworkRequestStatus.Success) {
                this.isEdited = true;
                this.isEditing = false;
            }
            if (result.status === NetworkRequestStatus.Error) {
                this.isEditing = true;
            }
        } finally {
            this.isSaving = false;
        }
    }
}
